/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EvaluationMonitoringParams } from './evaluationMonitoringParams';

/**
 * Request model for evaluation monitoring job
 */
export interface RunEvaluationMonitoringJobRequest {
  type: 'evaluation_monitoring';
  params: EvaluationMonitoringParams;
  allowOverlappingJobs?: boolean;
}
